import DateInput from "../../library/components/DateInput";
import InputField from "../../library/components/InputField";
import SelectField from "../../library/components/Select";
import TextAreaField from "../../library/components/textarea/index";
import Button from "../../library/components/Button";
import "./index.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import UploadFile from "../../library/components/FileUpload";
import { useState } from "react";
// import { commonApi }  from "../../../services/commonService";
import { commonApi } from "../../services/commonService";
import { useEffect } from "react";
import { Validators } from "../../library/utilities/Validator";
import ReactSelect from "../../ui/reactSelect";
import { downloadFile, parseJwt } from "../utilities/utils";
import { createAlert } from "../../features/alert/alerts";
import {
    ALERT_TYPE_SUCCESS,
    ALERT_TYPE_ERROR,
    FILED_IS_REQUIRED,
    ENTER_VALID_EMAIL,
  } from "../../constants/constants";
import {
  objectStoreApi,
  useGetObjectStoreFileQuery,
  useDownloadObjectStoreFileQuery,
  useDeleteObjectStoreFileQuery,
} from "../../services/objectStoreServices";
import { RunnerUpHeader } from "../../ui";
import LeftMenu from "../AnalyticsModule/Left";
import { useDispatch } from "react-redux";
import { useGetElectionAnnouncedAcsQuery, useUploadFileMutation } from "../../services/User_management/userService";
import { useGetStatesRequestQuery } from "../../services/announceElection";
import RunnerUpHeaderNew from "../../ui/runnerUpHeader/RunnerUpHeaderNew";

const initialstate = [
  {
    value: "Data is Loading....",
    label: "Data is Loading",
  },
];

const CreateUser = () => {
  const [state, setState] = useState();
  const [Error, setError] = useState({});
  const stateCode = parseJwt(localStorage.access_token)?.authorizedStates?.[0];
  const dispatch = useDispatch();
  const [uploadFile, datap] = useUploadFileMutation()
  const { data: statedata, isLoading: stateLoading } =
    useGetStatesRequestQuery();
  // const { data: districtdata, isLoading: districtLoading } =
  //   commonApi.useGetDistrictRequestQuery(stateCode, {
  //     skip: !stateCode ? true : false,
  //   });
  // const { data: Pcdata, isLoading: pcLoading } = commonApi.useGetPcByStateQuery(
  //   stateCode,
  //   {
  //     skip: state?.constType === "PC" ? false : true,
  //   }
  // );


  useEffect(()=>{
    if(localStorage.userrole=="ro"){
      setState((prevState) => ({
        ...prevState,
        "userType": "CS",
        "constType":parseJwt(localStorage?.access_token)?.constituencyType,
        "PC":parseJwt(localStorage?.access_token)?.authorizedPcs?.[0],
        "AC":parseJwt(localStorage?.access_token)?.authorizedAcs?.[0]
      }));
    }
  },[])


  const { data: acdata, isLoading: assemblyLoading } = 
  useGetElectionAnnouncedAcsQuery()
  const populatedStateList = [];
  // const populatedDistrictList = [];
  const populatedAC = [];
  const populatedPC = [];

  if (!stateLoading) {
    for (let i = 0; i < statedata.length; i++) {
      if (statedata[i].stateCd === stateCode) {
        populatedStateList.push({
          value: statedata[i].stateCd,
          label: statedata[i].stateName.toUpperCase(),
        });
      }
    }
  }

  // if (!districtLoading) {
  //   for (let i = 0; i < districtdata.length; i++) {
  //       populatedDistrictList.push({
  //           districtCd: districtdata[i].districtCd,
  //           districtValue: `${districtdata[i].districtNo} - ${districtdata[i].districtValue.toUpperCase()}` ,
  //       });
  //   }
  // }

  if (!assemblyLoading) {
    const acDatapayload = acdata?.payload?.assemblyDetailsDto;
    const pcDatapayload = acdata?.payload?.pcDetailsDto;
    for (let i = 0; i < acDatapayload?.length; i++) {
        populatedAC.push({
            asmblyNo: acDatapayload[i].acNo,
            asmblyName: `${acDatapayload[i].acNo} - ${acDatapayload[i].acName.toUpperCase()}` ,
        });
  }
  for (let i = 0; i < pcDatapayload?.length; i++) {
      populatedPC.push({
        prlmntNo: pcDatapayload[i].pcNo,
        parliamentName: `${pcDatapayload[i].pcNo} - ${pcDatapayload[i].pcName.toUpperCase()}` ,
    });
}
}

  const handleChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getErrorValue = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const roleList = [
    // { label: "Returning Officer", value: "RO" },
    { label: "Counting Supervisor", value: "CS" },
  ];
  const constList = [
    { label: "PC", value: "PC" },
    { label: "AC", value: "AC" },
  ];

  const handleSaveClick = () => {
    let error = {};
    if (!state?.constType || state?.constType === "") {
      error["constType"] = "This field is required";
    }
    if (!state?.userType || state?.userType === "") {
      error["userType"] = "This field is required";
    }
    if (!state?.firstname || state?.firstname === "") {
      error["firstname"] = "This field is required";
    }
    if (!stateCode || stateCode === "") {
      error["state"] = "This field is required";
    }
    if ((!state?.PC || state?.PC === "" ) && state?.constType ==="PC") {
      error["PC"] = "This field is required";
    }
    if ((!state?.AC || state?.AC === "" ) && state?.constType ==="AC"){
      error["AC"] = "This field is required";
    }
    if (!state?.userDesignation || state?.userDesignation === "") {
      error["userDesignation"] = "This field is required";
    }
    if (!state?.mobilenumber || state?.mobilenumber === "") {
      error["mobilenumber"] = "This field is required";
    }
    if (!state?.email || state?.email === "") {
      error["email"] = "This field is required";
    }
  //  if (
  //       state?.email != "" &&
  //       !new RegExp(/^[^\s@]+@(gov|eci|nic)\.in$/).test(state?.email)
  //     ) {
  //       error["email"] = "Please enter valid email";
  //     }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }

    const tempArray = []

    if(state.userType==="RO"||state.userType==="CS"){
        tempArray.push(
            {
                userType: state?.userType,
                userName: `${state?.firstname} ${(state?.lastname===null || state?.lastname===undefined)?"":state?.lastname}`,
                userDesignation: state?.userDesignation,
                userAddress: null,
                userMobile: state?.mobilenumber,
                userEmail: state?.email,
                userAadhar: null,
                stateCd: stateCode,
                districtCd: state?.district,
                constituencyType: state?.constType,
                constituencyNumber: state?.constType==="AC"?state?.AC:state?.PC,
            }
        )
    }

    uploadFile(
        {
            fileType: state?.userType==="RO" ?'Upload RO list':'Upload Counting Supervisor',
            stateCd: stateCode,
            constType: state.constType,
            recordList: [],
            nodalList: [],
            unitList: [],
            countingSupervisorList:
            state?.userType==="CS" ? tempArray : [],
            roOfficerList: state?.userType==="RO" ? tempArray : [],
        }
    )
  };

  const onSuccess = (msg) => {
    dispatch( 
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
useEffect(()=>{
    if(datap.isSuccess){
        onSuccess(`User Created Successfully with User id - ${datap.data?.payload?.[0]?.userId}`)
        if(localStorage.userrole=="ro"){
          setState((prevState) => ({
            "userType": "CS",
            "constType":parseJwt(localStorage?.access_token)?.constituencyType,
            "PC":parseJwt(localStorage?.access_token)?.authorizedPcs?.[0],
            "AC":parseJwt(localStorage?.access_token)?.authorizedAcs?.[0]
          }));
        }else{
          setState({})
        }
    }
},[datap.isSuccess])

  return (
    <LeftMenu>
      <div className="container-fluid box">
        <RunnerUpHeaderNew
          title={"Create User"}
          state={<span>State:{populatedStateList?.[0]?.label}</span>}
        />
           <div className="row offset-md-1 offset-0 p-2">
          <SelectField
            required={true}
            name="state"
            label="STATE"
            id="state"
            valueKey="stateCd"
            labelKey="stateName"
            disabled={true}
            options={
              populatedStateList.length
                ? [
                    {
                      stateName: populatedStateList[0].label,
                      stateCd: populatedStateList[0].value,
                    },
                  ]
                : []
            }
            validators={[
              {
                check: Validators.required,
                message: "Please select the state",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            labelClass="col-md-3"
            inputClass="col-md-4"
            value={state?.state}
            handleChange={(val) => handleChange("state", val)}
            Error={Error}
          ></SelectField>
        </div>

        <div className="row offset-md-1 offset-0 p-2">
          <SelectField
            required={true}
            name="constType"
            label="Constituency Type"
            disabled={localStorage.userrole==="ro" && true}
            valueKey="value"
            labelKey="label"
            options={[
              { label: "Select Constituency Type", value: "" },
              ...constList,
            ]}
            validators={[
              {
                check: Validators.required,
                message: "Please select the Constituency Type",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            labelClass="col-md-3"
            inputClass="col-md-4"
            value={state?.constType}
            getError={(value) => getErrorValue("constType", value)}
            Error={Error}
            handleChange={(val) => handleChange("constType", val)}
          ></SelectField>
        </div>

        {state?.constType === "PC" ? (
          <div className="row offset-md-1 offset-0 p-2">
            <SelectField
              required={true}
              name="PC"
              label="Parliamentary Constituency "
              disabled={localStorage.userrole==="ro" && true}
              valueKey="prlmntNo"
              labelKey="parliamentName"
              options={
                populatedPC != null
                  ? [{ parliamentName: "Select PC", prlmntNo: "" }, ...populatedPC]
                  : [{ parliamentName: "Select PC", prlmntNo: "" }]
              }
              validators={[
                {
                  check: Validators.required,
                  message: "Please select the Constituency",
                },
              ]}
              labelClass="col-md-3"
              inputClass="col-md-4"
              value={state?.PC}
              handleChange={(val) => handleChange("PC", val)}
              Error={Error}
            ></SelectField>
          </div>
        ) : state?.constType === "AC" ? (
          <div className="row offset-md-1 offset-0 p-2">
            <SelectField
              required={true}
              name="AC"
              label="Assembly Constituency "
              disabled={localStorage.userrole==="ro" && true}
              valueKey="asmblyNo"
              labelKey="asmblyName"
              options={
                populatedAC != null
                  ? [{ asmblyName: "Select AC", asmblyNo: "" }, ...populatedAC]
                  : [{ asmblyName: "Select AC", asmblyNo: "" }]
              }
              validators={[
                {
                  check: Validators.required,
                  message: "Please select the Constituency",
                },
              ]}
              labelClass="col-md-3"
              inputClass="col-md-4"
              value={state?.AC}
              handleChange={(val) => handleChange("AC", val)}
              Error={Error}
            ></SelectField>
          </div>
        ):null}
        
        <div className="row offset-md-1 offset-0 p-2">
          <SelectField
            required={true}
            name="userType"
            label="USER TYPE"
            valueKey="value"
            labelKey="label"
            disabled={localStorage.userrole==="ro" && true}
            options={[{ label: "Select Role", value: "" }, ...roleList]}
            validators={[
              {
                check: Validators.required,
                message: "Please select the designation",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            labelClass="col-md-3"
            inputClass="col-md-4"
            value={state?.userType}
            getError={(value) => getErrorValue("userType", value)}
            handleChange={(val) => handleChange("userType", val)}
            Error={Error}
          ></SelectField>
        </div>

        <div className="row offset-md-1 offset-0 p-2">
          <InputField
            name="firstname"
            label="First Name"
            placeholder={"First Name"}
            required={true}
            type="text"
            labelClass="col-md-3"
            inputClass="col-md-4"
            validators={[
              {
                check: Validators.firstName,
                message: "Please enter valid name",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
              {
                check: Validators.nameLength,
                message: "Name should be less than 50 chracters",
              },
            ]}
            value={state?.firstname}
            onChange={(val) => handleChange("firstname", val)}
            getError={(value) => getErrorValue("firstname", value)}
            Error={Error}
          />
        </div>

        <div className="row offset-md-1 offset-0 p-2">
          <InputField
            label="Last Name"
            placeholder={"Last Name"}
            type="text"
            labelClass="col-md-3"
            inputClass="col-md-4"
            value={state?.lastname}
            validators={[
              {
                check: Validators.firstName,
                message: "Please enter valid name",
              },
              {
                check: Validators.nameLength,
                message: "Name should be less than 50 chracters",
              },
            ]}
            onChange={(val) => handleChange("lastname", val)}
            getError={(value) => getErrorValue("lastname", value)}
            Error={Error}
          />
        </div>

        <div className="row offset-md-1 offset-0 p-2">
          <InputField
            name={"userDesignation"}
            label="User Designation"
            placeholder={"User Designation"}
            required={true}
            maxLength={50}
            type="text"
            labelClass="col-md-3"
            inputClass="col-md-4"
            value={state?.userDesignation}
            validators={[
              {
                check: Validators.nospecialReason,
                message: "Please enter valid name",
              },
                {
                  check: Validators.required,
                  message: "Please enter the user designation",
                },              
            ]}
            onChange={(val) => handleChange("userDesignation", val)}
            getError={(value) => getErrorValue("userDesignation", value)}
            Error={Error}
          />
        </div>

     
{/* 
        <div className="row offset-md-1 offset-0 p-2">
          <SelectField
            required={true}
            disabled={false}
            name="district"
            label="DISTRICT"
            options={
                populatedDistrictList != null
                ? [
                    { districtValue: "Select District", districtCd: "" },
                    ...populatedDistrictList,
                  ]
                : [{ districtValue: "Select District", districtCd: "" }]
            }
            validators={[
              {
                check: Validators.required,
                message: "Please select the district",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            valueKey="districtCd"
            labelKey="districtValue"
            labelClass="col-md-3"
            inputClass="col-md-4"
            value={state?.district}
            handleChange={(val) => handleChange("district", val)}
            Error={Error}
          ></SelectField>
        </div> */}

      

        <div className="row offset-md-1 offset-0 p-2">
          <InputField
            name="mobilenumber"
            label="Mobile Number"
            required={true}
            labelClass="col-md-3"
            placeholder={"Mobile Number"}
            inputClass="col-md-4"
            value={state?.mobilenumber}
            validators={[
              {
                check: Validators.mobile,
                message: "Please enter valid mobile number",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            onChange={(val) => handleChange("mobilenumber", val)}
            getError={(value) => getErrorValue("mobilenumber", value)}
            Error={Error}
          />
        </div>

        <div className="row offset-md-1 offset-0 p-2">
          <InputField
            name="email"
            label="Email Address"
            placeholder={"Email Address"}
            type="text"
            required={true}
            labelClass="col-md-3"
            inputClass="col-md-4"
            validators={[
              {
                check: Validators.emailCEODEO,
                message: ENTER_VALID_EMAIL,
              },
              {
                check: Validators.required,
                message: FILED_IS_REQUIRED,
              },
            ]}
            value={state?.email}
            onChange={(val) => handleChange("email", val)}
            getError={(value) => getErrorValue("email", value)}
            Error={Error}
          />
        </div>

        <center>
          <div className="p-2">
            <Button
              onClick={() => {
                handleSaveClick();
              }}
              btnClass="save-btn"
              value="&nbsp; Submit &nbsp;"
              disabled={datap.isLoading}
            ></Button>
          </div>
        </center>
      </div>
    </LeftMenu>
  );
};

export default CreateUser;
